const actions = {
    DASHBOARD_ALL_REQUEST: 'DASHBOARD_ALL_REQUEST',
    DASHBOARD_ALL_SUCCESS: 'DASHBOARD_ALL_SUCCESS',
    DASHBOARD_ALL_ERROR: 'DASHBOARD_ALL_ERROR',
    DASHBOARD_OUTSTANDINGS_REQUEST: 'DASHBOARD_OUTSTANDINGS_REQUEST',
    DASHBOARD_OUTSTANDINGS_SUCCESS: 'DASHBOARD_OUTSTANDINGS_SUCCESS',
    DASHBOARD_OUTSTANDINGS_ERROR: 'DASHBOARD_OUTSTANDINGS_ERROR',
    DASHBOARD_SALES_TREND_REQUEST: 'DASHBOARD_SALES_TREND_REQUEST',
    DASHBOARD_SALES_TREND_SUCCESS: 'DASHBOARD_SALES_TREND_SUCCESS',
    DASHBOARD_SALES_TREND_ERROR: 'DASHBOARD_SALES_TREND_ERROR',
    DASHBOARD_PROFIT_LOSS_TREND_REQUEST: 'DASHBOARD_PROFIT_LOSS_TREND_REQUEST',
    DASHBOARD_PROFIT_LOSS_TREND_SUCCESS: 'DASHBOARD_PROFIT_LOSS_TREND_SUCCESS',
    DASHBOARD_PROFIT_LOSS_TREND_ERROR: 'DASHBOARD_PROFIT_LOSS_TREND_ERROR',
    DASHBOARD_CASHFLOW_TREND_REQUEST: 'DASHBOARD_CASHFLOW_TREND_REQUEST',
    DASHBOARD_CASHFLOW_TREND_SUCCESS: 'DASHBOARD_CASHFLOW_TREND_SUCCESS',
    DASHBOARD_CASHFLOW_TREND_ERROR: 'DASHBOARD_CASHFLOW_TREND_ERROR',
    DASHBOARD_CASHFLOW_FORECAST_REQUEST: 'DASHBOARD_CASHFLOW_FORECAST_REQUEST',
    DASHBOARD_CASHFLOW_FORECAST_SUCCESS: 'DASHBOARD_CASHFLOW_FORECAST_SUCCESS',
    DASHBOARD_CASHFLOW_FORECAST_ERROR: 'DASHBOARD_CASHFLOW_FORECAST_ERROR',
    DASHBOARD_BANK_ACCOUNTS_REQUEST: 'DASHBOARD_BANK_ACCOUNTS_REQUEST',
    DASHBOARD_BANK_ACCOUNTS_SUCCESS: 'DASHBOARD_BANK_ACCOUNTS_SUCCESS',
    DASHBOARD_BANK_ACCOUNTS_ERROR: 'DASHBOARD_BANK_ACCOUNTS_ERROR',
    DASHBOARD_SALES_LIST_REQUEST: 'DASHBOARD_SALES_LIST_REQUEST',
    DASHBOARD_SALES_LIST_SUCCESS: 'DASHBOARD_SALES_LIST_SUCCESS',
    DASHBOARD_SALES_LIST_ERROR: 'DASHBOARD_SALES_LIST_ERROR',
    DASHBOARD_INCOME_BREAKDOWN_REQUEST: 'DASHBOARD_INCOME_BREAKDOWN_REQUEST',
    DASHBOARD_INCOME_BREAKDOWN_SUCCESS: 'DASHBOARD_INCOME_BREAKDOWN_SUCCESS',
    DASHBOARD_INCOME_BREAKDOWN_ERROR: 'DASHBOARD_INCOME_BREAKDOWN_ERROR',
    DASHBOARD_EXPENSE_BREAKDOWN_REQUEST: 'DASHBOARD_EXPENSE_BREAKDOWN_REQUEST',
    DASHBOARD_EXPENSE_BREAKDOWN_SUCCESS: 'DASHBOARD_EXPENSE_BREAKDOWN_SUCCESS',
    DASHBOARD_EXPENSE_BREAKDOWN_ERROR: 'DASHBOARD_EXPENSE_BREAKDOWN_ERROR',
    DASHBOARD_RESET_STATE: 'DASHBOARD_RESET_STATE',

    getAll: () => ({
        type: actions.DASHBOARD_ALL_REQUEST,
    }),
    getOutstandings: () => ({
        type: actions.DASHBOARD_OUTSTANDINGS_REQUEST,
    }),
    getSalesTrend: (request = {
        preset: false, is_cash_basis: false, tag_group_id: null, custom_preset_period: null,
    }) => ({
        type: actions.DASHBOARD_SALES_TREND_REQUEST,
        request,
    }),
    getProfitLossTrend: (request = {
        preset: false, is_cash_basis: false, tag_group_id: null, custom_preset_period: null,
    }) => ({
        type: actions.DASHBOARD_PROFIT_LOSS_TREND_REQUEST,
        request,
    }),
    getCashflowTrend: (request = {preset: null, custom_preset_period: null}) => ({
        type: actions.DASHBOARD_CASHFLOW_TREND_REQUEST,
        request,
    }),
    getCashflowForecast: (request = {preset: null, custom_preset_period: null}) => ({
        type: actions.DASHBOARD_CASHFLOW_FORECAST_REQUEST,
        request,
    }),
    getBankAccounts: (preset = null) => ({
        type: actions.DASHBOARD_BANK_ACCOUNTS_REQUEST,
        preset,
    }),
    getSalesList: () => ({
        type: actions.DASHBOARD_SALES_LIST_REQUEST,
    }),
    getIncomeBreakdown: request => ({
        type: actions.DASHBOARD_INCOME_BREAKDOWN_REQUEST,
        request,
    }),
    getExpenseBreakdown: request => ({
        type: actions.DASHBOARD_EXPENSE_BREAKDOWN_REQUEST,
        request,
    }),
    resetState: () => ({
        type: actions.DASHBOARD_RESET_STATE,
    }),
};
export default actions;
